export const unixToDate = unix => {
    const date = new Date(unix)
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`
}

const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]